<template>
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
  >
    <path d="M0.246643 3.03807V8C0.246643 9.10457 1.14207 10 2.24664 10H10.2466C11.3512 10 12.2466 9.10457 12.2466 8V2C12.2466 0.895431 11.3512 0 10.2466 0H2.24664C1.14207 0 0.246643 0.89543 0.246643 2V3.03807C0.246643 3.03804 0.246643 3.03809 0.246643 3.03807ZM2.24664 1H10.2466C10.7989 1 11.2466 1.44772 11.2466 2V2.73987L6.24674 5.43212L1.24664 2.73976V2C1.24664 1.44772 1.69436 1 2.24664 1ZM1.24664 3.87552L6.00969 6.44024C6.15768 6.51992 6.3358 6.51992 6.48379 6.44024L11.2466 3.87562V8C11.2466 8.55229 10.7989 9 10.2466 9H2.24664C1.69436 9 1.24664 8.55228 1.24664 8V3.87552Z" />
  </svg>
</template>
